module.exports = __webpack_public_path__ + "src/img/index_menu/5.png?c38f2231c8aa8a02cd7a5ed5d80092d2";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/5.png
// module id = 178
// module chunks = 0